import Vue from 'vue'

const mutations = {

  /**
   * @param state
   * @param privileges
   */
  SET_PRIVILEGELIST (state, privileges) {
    if (state.privilege_list.length > 0) state.privilege_list.length = []
    for (let index = 0; index < privileges.length; index++) {
      state.privilege_list.push(privileges[index])
    }
  },

  SET_SELECTEDROLE (state, selectedRole) {
    state.selected_role = selectedRole
  },

  SET_PRIVILEGES_SELECTED_LEFT (state, privileges) {
    if (state.privileges_selected_left.length > 0) state.privileges_selected_left = []
    for (let index = 0; index < privileges.length; index++) {
      state.privileges_selected_left.push(privileges[index])
    }
  },

  SET_PRIVILEGES_SELECTED_RIGHT (state, privileges) {
    if (state.privileges_selected_right.length > 0) state.privileges_selected_right = []
    for (let index = 0; index < privileges.length; index++) {
      state.privileges_selected_right.push(privileges[index])
    }
  },

  ADD_PRIVILEGE_TO_PRIVILEGELIST (state, privilegeData) {
    state.privilege_list.push(privilegeData)
  },

  UPDATE_PRIVILEGE_IN_PRIVILEGELIST (state, privilegeData) {
    let updatedPrivilegeIndex = state.privilege_list.findIndex(oldPrivilege => oldPrivilege.id === privilegeData.id)
    if (updatedPrivilegeIndex !== -1) {
      Vue.set(state.privilege_list, updatedPrivilegeIndex, privilegeData)
    }
  }
}

export default mutations



//////////////////
// WEBPACK FOOTER
// ./state/privilege/privilege.mutations.js
// module id = null
// module chunks = 